/**
 * Constants for Secure Messages V2
 */

export const MESSAGE_TYPES = {
  THREAD: 'thread',
  REPLY: 'reply',
  SIDEBAR: 'sidebar',
};

export const MESSAGE_STATUS = {
  READ: 'true',
  UNREAD: 'false',
  SCHEDULED: 'scheduled',
  ALL: '',
};

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 1000,
  SORT_ORDER: {
    ASC: 'asc',
    DESC: 'desc',
  },
};

export const AUTO_SAVE_INTERVAL_MS = 5000;
export const REPLY_AUTO_SAVE_DEBOUNCE_MS = 1000;
export const MAX_FILE_ATTACHMENTS = 20;

export const ACCEPTED_FILE_TYPES =
  'application/pdf, application/msword, .docx, .doc, audio/*, video/*, image/*, .heic, .heif, image/heic, image/heif, .xls, .xlsx';

export const WEBSOCKET_EVENTS = {
  SECURE_MESSAGE: 'secure_message',
  SIDEBAR_MESSAGE: 'sidebar_message',
  SERVER_STATUS: 'server_status',
};

export const NOTIFICATION_TYPE = {
  SECURE_MESSAGE: 'secure_message',
};
